import * as React from "react";

function SvgArrowBottom(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 10.586V2h2v8.586l3.293-3.293 1.414 1.414L8 14.414 2.293 8.707l1.414-1.414L7 10.586z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgArrowBottom;
